import Button from '@material-ui/core/Button';
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDialogsContext } from '../../contexts/Dialog';
import { DialogNames } from '../../Types';

const useStyles = makeStyles((theme: any) => ({
  button: {
    borderRadius: theme.spacing(0.5),
    fontSize: 'large',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    width: 250,
  },
  rejectButton: {
    backgroundColor: theme.palette.brand.greyLight,
  },
}));

export function AcceptAndActiveButton({ openContractAddendum }) {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      className={classes.button}
      color="primary"
      onClick={() => {
        openContractAddendum();
      }}
    >
      <b>Accept {'&'} Activate</b>
    </Button>
  );
}

export function DeclineButton() {
  const dialog = useDialogsContext();
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      className={`${classes.button} ${classes.rejectButton}`}
      onClick={() => {
        dialog.open(DialogNames.RejectEditedPlan);
      }}
    >
      <b>Decline</b>
    </Button>
  );
}

export function ProposeAlternativeButton() {
  const dialog = useDialogsContext();
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      className={`${classes.button} ${classes.rejectButton}`}
      onClick={() => {
        dialog.open(DialogNames.ProposeAlternativePlan);
      }}
    >
      <b>Propose an Alternative</b>
    </Button>
  );
}
